export var EditModeWorld;
(function (EditModeWorld) {
    EditModeWorld["KARA"] = "KARA";
    EditModeWorld["TREE"] = "TREE";
    EditModeWorld["LEAF"] = "LEAF";
    EditModeWorld["MUSHROOM"] = "MUSHROOM";
    EditModeWorld["DELETE"] = "DELETE";
})(EditModeWorld || (EditModeWorld = {}));
export const initialDialogStateKara = {};
export const initialMachineStateKara = {};
export const initialState = {
    machineState: initialMachineStateKara,
    dialogState: initialDialogStateKara,
    fullscreen: false,
};
